export default __webpack_public_path__ + "static/media/Ellipse 138.d288ab98.svg";